exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.swap-item-button .swap-item-icon[data-v-7bfaa0dd] {\n  height: 19px;\n  vertical-align: middle;\n  fill: #B0B0B0;\n}\n.swap-item-button .swap-item-icon--white[data-v-7bfaa0dd] {\n  fill: #FFFFFF;\n}\n.swap-item-button .swap-item-text[data-v-7bfaa0dd] {\n  margin-left: 6px;\n}", ""]);

// exports
